// removed by extract-text-webpack-plugin
module.exports = {"root":"_1q8G6","title":"_5ZIM9","container":"_16pHx","channelBlock":"_28z04","latestPostBlock":"_2zbJU"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/SubjectPage/SubjectPage.scss
// module id = 1515
// module chunks = 2